module.exports = __webpack_public_path__ + "img/bg.359f4496.png";